/* admin_localities */
export const GET_ADDRESS_ACCESS_REQUEST =
  'resources/admin/localities/GET_ADDRESS_ACCESS_REQUEST'
export const GET_ADDRESS_ACCESS_SUCCESS =
  'resources/admin/localities/GET_ADDRESS_ACCESS_SUCCESS'
export const GET_ADDRESS_ACCESS_ERROR =
  'resources/admin/localities/GET_ADDRESS_ACCESS_ERROR'
